import { render, staticRenderFns } from "./mainLogo.vue?vue&type=template&id=f452e468&scoped=true&"
import script from "./mainLogo.vue?vue&type=script&lang=js&"
export * from "./mainLogo.vue?vue&type=script&lang=js&"
import style0 from "./mainLogo.vue?vue&type=style&index=0&id=f452e468&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f452e468",
  null
  
)

export default component.exports